import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-block-item-download-app',
  templateUrl: './block-item-download-app.component.html',
  styleUrls: ['./block-item-download-app.component.scss']
})
export class BlockItemDownloadAppComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
